import {defineAbilityConfig} from '../system/defineAbilityConfig';

// Whether users can access the canvas bar that shows up on the top/bottom of the canvas.
export const canAccessCanvasBar = defineAbilityConfig([
  {
    workflows: {
      canvas: true,
      preview: true,
      webApps: true,
      comment: true,
      analyzeVisualView: true,
    },
  },
] as const);

// Whether users can access the canvas settings on the canvas bar, that
// allows them to change some settings like Vision preview, width and scale,
// rulers, canvas bar position, and others.
export const canAccessCanvasSettings = defineAbilityConfig([
  {
    userTypes: {
      authorizedInDesigner: true,
      unauthorized: true,
    },
    siteModes: {design: true, edit: true},
    workflows: {
      canvas: true,
      preview: true,
      webApps: true,
      analyzeVisualView: true,
    },
  },
] as const);

// Whether users can add larger breakpoints to the site.
export const canAddLargerBreakpoints = defineAbilityConfig([
  {
    siteModes: {design: true},
    workflows: {canvas: true, analyzeVisualView: true},
  },
] as const);

// Whether users can access the custom code preview toggle on the canvas bar
// that will allow them to execute custom code in preview mode.
export const canAccessCustomCodePreview = defineAbilityConfig([
  {
    workflows: {preview: true, webApps: true, comment: true},
  },
] as const);

// Whether users can access the breadcrumbs that show up on the canvas bar
// when they select an element on the canvas.
export const canAccessBottomBreadcrumbs = defineAbilityConfig([
  {
    siteModes: {design: true},
    workflows: {canvas: true, preview: false},
  },
  {
    branches: {
      branch: true,
    },
    siteModes: {design: true},
    workflows: {canvas: true, preview: false},
  },
] as const);

// Whether users can access the grid overlay that shows up on top of the canvas
// when they change their guide canvas settings.
export const canAccessGridOverlay = defineAbilityConfig([
  {
    siteModes: {design: true, view: false},
    workflows: {canvas: true, preview: true},
  },
] as const);

export const canDisplaySeparateOriginCanvas = defineAbilityConfig([
  {
    workflows: {canvas: false, preview: true, comment: true},
  },
] as const);
